

interface InfoDate{
    day: number
    month:number
    year:number
    hour:number
    minute:number
    second:number
    timezone:string
}
function InfoDateFromParts(parts:Intl.DateTimeFormatPart[]){
    console.log(parts)
    var InfoDate ={
        day: 0,
    month:0,
    year:0,
    hour:0,
    minute:0,
    second:0,
    timezone:'UTC'
    }
    parts.forEach((part)=>{
        console.log("processing part:",part)
        switch(part.type){
            case "day":
                console.log("day:",part.type,part.value)
                InfoDate.day=Number(part.value)
                break
            case "hour":
                console.log("hour:",part.type,part.value)
                InfoDate.hour=Number(part.value)
                break
            case "minute":
                console.log("minute:",part.type,part.value)
                InfoDate.minute=Number(part.value)
                break
            case "month":
                console.log("month:",part.type,part.value)
                InfoDate.month=Number(part.value)
                break
            case "second":
                console.log("second:",part.type,part.value)
                InfoDate.second=Number(part.value)
                break
            case "timeZoneName":
                console.log("tz:",part.type,part.value)
                InfoDate.timezone=part.value
                break
            case "year":
                console.log("year:",part.type,part.value)
                InfoDate.year=Number(part.value)
                break
           
        }
    })
    return InfoDate
}
function isInfoDateBefore2(date1:InfoDate, date2:InfoDate):boolean{
    if (date1.day>date2.day){
        if(date1.month<date2.month){
            return true
        }
        if (date1.year<date2.year){
            return true
        }
        return false
    }
    return true
}
function isInfoDateTimeBefore(date:InfoDate, target:InfoDate):boolean{
    if (date.year<target.year){
        return true
    }
    //year is not before target year
    if (date.month<target.month){
        return true
    }
    //month is not before target month
    if (date.day<target.day){
        return true
    }
    //day is not before target day
    if (date.hour<target.hour){
        return true
    }
    //hour is not before target hour
    if (date.minute<target.minute){
        return true
    }
    //minute is not before target minute
        if (date.second<target.second){
        return true
    }
    //second is not before target second
    return false
}
function isInfoDateBefore(date:InfoDate, target:InfoDate):boolean{
    if (date.year<target.year){
        return true
    }
    //year is not before target year
    if (date.month<target.month){
        return true
    }
    //month is not before target month
    if (date.day<target.day){
        return true
    }
    //day is not before target day
    return false
}
export function epochSecondsToHours(seconds:number):number{
    //console.log('delta seconds:', seconds)
    const remainder = seconds%3600
    seconds = seconds+remainder
    return seconds/3600000
}

export function createTzRange(){
    const options = []
    let tz = -12
    while (tz<14){
        options.push(tz)
        tz=tz+1
    }
    return options
}

export function roundEpochUpToHour(seconds:number):number{
    const remainder = seconds%3600
    seconds = seconds+remainder
    return seconds
}

export function getTzOffsetSecondsOld(tz:string):number{
    const dateFormatUTC = new Intl.DateTimeFormat('en-US', {
    year:"numeric",
    month:"numeric",
    day:"numeric",
    timeZone: "UTC",
    hourCycle: "h24",
    hour:"2-digit",
    minute:"2-digit",
    second:"2-digit"
    });
    const dateFormatTZ = new Intl.DateTimeFormat('en-US', {
    timeZone: tz,
    year:"numeric",
    month:"numeric",
    day:"numeric",
    hourCycle: "h24",
    hour:"2-digit",
    minute:"2-digit",
    second:"2-digit"
    });
    const partsUTC = dateFormatUTC.formatToParts(new Date())
    const partsTZ = dateFormatTZ.formatToParts(new Date())
    
    return getOffsettFromParts(partsUTC,partsTZ)
}

function getOffsettFromParts(utc:Intl.DateTimeFormatPart[], tz:Intl.DateTimeFormatPart[]){
    const utcDate = InfoDateFromParts(utc)
    const tzDate = InfoDateFromParts(tz)
    //console.log("utc date:",utcDate)
    //console.log("tz date:",tzDate)
    var offset:number
    const utcSeconds = utcDate.hour*60*60+utcDate.minute*60+utcDate.second
    const tzSeconds = tzDate.hour*60*60+tzDate.minute*60+tzDate.second
    //console.log("total utc seconds:", utcSeconds)
    //console.log("total tz seconds:",tzSeconds)
    if (isInfoDateTimeBefore(tzDate,utcDate)){ 
        //console.log("tz is before utc")
        if(isInfoDateBefore){

        }
        offset = tzSeconds-utcSeconds
    }else{
        console.log("tz is ahead of utc")
        offset = tzSeconds-utcSeconds
    }
    console.log("offset:",offset)
    return offset
}
export function getTzOffsetSeconds(tz:string){
    const baseDate = new Date()
    const utcDate = new Date(baseDate.toLocaleString('en-US',{timeZone:"UTC"}))
    const tzDate = new Date(baseDate.toLocaleString('en-US',{timeZone:tz}))
    const offset = tzDate.getUTCSeconds()-utcDate.getUTCSeconds()
    console.log("utcDate",utcDate)
    console.log("tzdate:",tzDate)
    console.log("offset:",offset)
    return offset
}
export function getTZoffesetFromTZ(tz:string){
    const baseDate = new Date()
    const formatter = new Intl.DateTimeFormat('en-US', {timeZone:tz,timeZoneName:'shortOffset'});
    const parts = formatter.formatToParts(baseDate);
    const tzPart = parts.find(p => p.type === 'timeZoneName');
    const match = tzPart.value.match(/GMT([+-]\d{1,2})(?::(\d{2}))?/);
        if (!match) return 0; // GMT with no offset means UTC
    const hours = parseInt(match[1], 10)
    //console.log("tzPart:",tzPart)
    //console.log("hours:",hours)
    return hours*3600

}